module.exports = __webpack_public_path__ + "img/emision_atmosferica.5be16c1e.png";